import { Divider } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import Media from 'react-media';
import useMediaQuery from '@mui/material/useMediaQuery';
import SwiperCore, { Pagination, Navigation } from 'swiper';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Card, CardMedia, CardContent, Slider } from '@mui/material';

import { IUserFromStorage } from '../../Interfaces/IUser';
import { IProducto, IProductos } from '../../Interfaces/IProductos';
import Loading from '../../Utils/Loading';
import SwiperProductos from './CustomSwiper/SwiperProductos';
import DialogProductDescription from '../Dialog/DialogProductDescription';
import SwiperProductosAdquiridos from './CustomSwiper/SwiperProductosAdquiridos';
// import SliderComponet from '../../Utils/Slider';

import imgBolsa from '../../Shared/Images/bolsa.png';
import iconInicio from '../../Shared/Images/bienvenido-icon.png';

// Importar estilos de swiper
// import SwiperProductosEnVenta from './InicioComponents/SwiperProductosEnVenta';
// import SwiperProductosEnVentaMobile from './InicioComponents/SwiperProductosEnVentaMobile';

import 'swiper/swiper.min.css';
import './styles/inicioMobile.css';
// import stylesModule from './styles/stylesInicio.module.css';
// Instalar los módulos de paginación y navegación en swiper
SwiperCore.use([Pagination, Navigation]);

export interface IInicio {
  productos: IProductos;
}

const Inicio = ({ productos } : IInicio) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isCompras, setIsCompras] = useState(false);
  const [producto, setProduct] = useState<IProducto>();
  const [loading, setLoading] = useState<boolean>(true);
  const [userName, setUserName] = useState('');
  const isMobile = useMediaQuery('(max-width: 650px)');
  const stateStr = localStorage.getItem('state');
  const state = stateStr ? JSON.parse(stateStr) : null;
  const userStr = localStorage.getItem('user');
  const user: IUserFromStorage | null = userStr ? JSON.parse(userStr) : null;
  // let dataUser = typeof user === 'string' ? JSON.parse(user) : '';

  // querys

  // const tabletCol = useMediaQuery('(max-width: 650px)');
  // const matches2 = useMediaQuery('(max-width: 1025px)');
  // const matches3 = useMediaQuery('(max-width: 1250px)');

  // const [swiperInstance, setSwiperInstance] = useState<any>(null);

  // const goNext = () => {
  //   if (swiperInstance && swiperInstance.slideNext) {
  //     swiperInstance.slideNext();
  //   }
  // };

  // const goPrev = () => {
  //   if (swiperInstance && swiperInstance.slidePrev) {
  //     swiperInstance.slidePrev();
  //   }
  // };

  // const navigate = useNavigate();

  useEffect(() => {
    if (productos) {
      setLoading(false);
      // console.log(productos);
    }
    if (localStorage.getItem('user')) {
      const item = JSON.parse(localStorage.getItem('user')!);
      setUserName(item.nombres);
    }
  }, [ productos ]);

  if(user && user.respondio && user.esReto && !user.subioVideo) {
    return <Navigate to={'/uploadVideo'} replace />;
  }

  if (!user.videoVisto) {
    return <Navigate to={'/despuesTest'} replace />;
  }

  const greetingText = state && state.sexo ? 'Bienvenido' : 'Bienvenida';

  return (
    <>
      <div
        className={isMobile ? 'home-container' : 'mb-5 mt-3 w-full'}
        style={{ padding: isMobile ? '0 .5rem' : '0', width: '100%' }}
      >
        {!isMobile && <div className="h-[3vh] w-full"></div>}
        {loading ? (
          <div
            className="container flex items-center justify-center"
            style={{ height: '100vh', width: '100%' }}
          >
            <Loading />
          </div>
        ) : (
          <>
            <Media query="(min-width:600px)">
              {(matches) => {
                return matches ? (
                  <div style={{ width: '100%' }}>
                    <img
                      src={productos.sliders[0].portada}
                      style={{
                        objectFit: 'fill',
                        width: '100%',
                        marginTop: '.8rem',
                      }}
                    />
                  </div>
                ) : (
                  <div style={{ width: '100%' }}></div>
                );
              }}
            </Media>
            <div className="my-4" style={{ textAlign: 'start' }}>
              {isMobile && (
                <div className="home-welcome">
                  <div className="home-welcome-avatar">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                  </div>
                  <div className="home-welcome-text">
                    <span className="home-welcome-label">{greetingText}</span>
                    <h2 className="home-welcome-name">{userName}</h2>
                  </div>
                </div>
              )}
              <div
                style={{
                  padding: isMobile ? 0 : '0 2.5rem',
                  marginTop: isMobile ? 0 : '3.5rem',
                }}
              >

                {productos &&
                  productos.productosAdquiridos &&
                  productos.productosAdquiridos.length > 0 &&(
                  <>
                    {isMobile && <p className="home-section-title">Mis Productos</p>}
                    {!isMobile && <p className="font-bold text-2xl">Mis Productos</p>}
                    <SwiperProductosAdquiridos 
                      productos={productos.productosAdquiridos}
                      isCompras={isCompras}
                      setDialogOpen={setDialogOpen}
                      setIsCompras={setIsCompras}
                      setProduct={setProduct}
                    />
                  </>
                )}

                {isMobile && (
                  <Divider style={{ backgroundColor: 'black', marginBottom: '1rem' }} />
                )}

                {/* Te puede interesar */}
                <div>
                  {isMobile ? (
                    <div className="home-shop-header">
                      <div className="home-shop-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                          <line x1="3" y1="6" x2="21" y2="6" />
                          <path d="M16 10a4 4 0 0 1-8 0" />
                        </svg>
                      </div>
                      <p className="home-shop-title">
                        Hazte más FÁCIL tu vida fitness
                      </p>
                    </div>
                  ) : (
                    <div
                      className="flex items-center"
                      style={{
                        margin: '2rem 0',
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        gap: '1rem',
                        alignItems: 'center',
                      }}
                    >
                      <p className="font-bold text-lg md:text-2xl m-0">
                        Hazte más FÁCIL tu vida fitness:
                      </p>
                    </div>
                  )}

                  {/* {isMobile ? (
                    <div>
                      {.productos && .productos.productosEnVenta.length > 0 ? (
                        <>

                          <SwiperProductosEnVentaMobile
                            productos={.productos.productosEnVenta}
                            setDialogOpen={setDialogOpen}
                            setIsCompras={setIsCompras}
                            setProduct={setProduct}
                          />

                        </>
                      ) : (
                        <div
                          style={{
                            height: '80vh',
                            width: '100vw',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'absolute',
                            top: '60px',
                          }}
                        >
                          <Loading />
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <SwiperProductosEnVenta 
                        productos={.productos.productosEnVenta}
                        setProduct={setProduct}
                        setDialogOpen={setDialogOpen}
                        setIsCompras={setIsCompras}
                      />
                    </>  
                  )} */}

                  {productos &&
                    productos.minicursoEnVenta &&
                    productos.minicursoEnVenta.length > 0 && (
                      <>
                        <p className={isMobile ? 'home-category' : 'font-bold text-xl p-0 m-0'}>Minicursos</p>

                        <SwiperProductos 
                          productos={productos.minicursoEnVenta}
                          setProduct={setProduct}
                          setDialogOpen={setDialogOpen}
                          setIsCompras={setIsCompras}
                        />
                      </>
                  )}
                  {productos &&
                    productos.recetariosEnVenta &&
                    productos.recetariosEnVenta.length > 0 && (
                      <>
                        <p className={isMobile ? 'home-category' : 'font-bold text-xl p-0 m-0'}>Recetarios:</p>
                        
                        <SwiperProductos
                          productos={productos.recetariosEnVenta}
                          setProduct={setProduct}
                          setDialogOpen={setDialogOpen}
                          setIsCompras={setIsCompras}
                        />
                      </>
                  )}
                  {productos &&
                    productos.ebookEnVenta &&
                    productos.ebookEnVenta.length > 0 && (
                      <>
                        <p className={isMobile ? 'home-category' : 'font-bold text-xl p-0 m-0'}>Ebooks:</p>

                        <SwiperProductos
                          productos={productos.ebookEnVenta}
                          setProduct={setProduct}
                          setDialogOpen={setDialogOpen}
                          setIsCompras={setIsCompras}
                        />
                      </>
                  )}

                  { user && user.usuarioTestAsesoriaID === 18 && (
                    <div className="flex justify-center">
                      <Link to={'https://tr4iner.com/'} target="_blank">
                        <button className="mt-8 bg-secondYellowTr4iner w-fit px-3 text-center py-4 rounded-3xl font-bold text-lg uppercase text-black text-decoration-none">
                          Método 1 a 1
                        </button>
                      </Link>
                    </div>
                  )}

                </div>
              </div>
            </div>
            {dialogOpen && (
              <DialogProductDescription
                isOpen={dialogOpen}
                isCompras={isCompras}
                setIsOpen={setDialogOpen}
                setIsCompras={setIsCompras}
                producto={producto!}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Inicio;
